import { Helmet } from "react-helmet-async";
import { config } from "@/lib/config";
import "./LegalPages.css";

export function PrivacyPage() {
  return (
    <>
      <Helmet>
        <title>Privacy policy · {config.appName}</title>
        <link rel="canonical" href={`${config.publicSiteUrl}/privacy`} />
      </Helmet>
      <article className="legal-page">
        <h1 className="legal-page__title">Privacy policy</h1>
        <p className="legal-page__meta">
          Last updated placeholder — replace with counsel-approved copy before production.
        </p>
        <section className="legal-page__section">
          <h2>Information we collect</h2>
          <p>
            This placeholder describes categories such as account data, order history, device
            information, and communications. Replace with your actual data practices and lawful
            bases.
          </p>
        </section>
        <section className="legal-page__section">
          <h2>How we use information</h2>
          <p>
            Placeholder — fulfillment, compliance, fraud prevention, analytics, and marketing (with
            consent where required).
          </p>
        </section>
        <section className="legal-page__section">
          <h2>Your choices</h2>
          <p>
            Placeholder — access, correction, deletion, opt-out of marketing, and regional rights
            (e.g. where applicable).
          </p>
        </section>
      </article>
    </>
  );
}
